export default {"src":"/_next/static/media/white-loading.166a5e1f.svg","height":97,"width":97,"blurWidth":0,"blurHeight":0};